export const xrystalQuotes = [
  {
    name: 'Dr. Sarah Chen',
    quote:
      'Xrystal has transformed how our team approaches predictive analytics. The clarity of insights is unprecedented.',
  },
  {
    name: 'Marcus Rodriguez',
    quote:
      "The crystalline interface makes complex data feel intuitive. It's like seeing the future through a crystal ball.",
  },
  {
    name: 'Prof. Elena Vasquez',
    quote: 'Xrystal brings transparency to machine learning that I never thought possible. Truly revolutionary.',
  },
  {
    name: 'James Liu',
    quote:
      'The predictive accuracy combined with the beautiful interface makes Xrystal indispensable for our research.',
  },
  {
    name: 'Dr. Amira Hassan',
    quote: 'Xrystal turns data science into an art form. The insights emerge naturally, like light through a prism.',
  },
  {
    name: 'David Thompson',
    quote: 'I can finally explain our AI models to stakeholders. Xrystal makes the complex beautifully simple.',
  },
  {
    name: 'Dr. Yuki Tanaka',
    quote: 'The way Xrystal visualizes uncertainty and confidence is groundbreaking. It changes everything.',
  },
  {
    name: 'Maria Santos',
    quote: 'Xrystal helped us identify patterns we never saw before. The future has never been clearer.',
  },
  {
    name: 'Alex Kumar',
    quote: 'Working with Xrystal feels like having a conversation with the data itself. Incredibly intuitive.',
  },
  {
    name: 'Dr. Rachel Green',
    quote: 'The crystalline clarity of Xrystal insights has accelerated our research by months, not days.',
  },
  {
    name: 'Thomas Berg',
    quote: 'Xrystal transforms uncertainty into opportunity. Every prediction feels like looking into the future.',
  },
  {
    name: 'Dr. Priya Sharma',
    quote: 'The transparency Xrystal brings to AI decision-making is exactly what the field needed.',
  },
  {
    name: 'Carlos Mendoza',
    quote: 'Xrystal makes me feel like a data wizard. The insights just crystallize before your eyes.',
  },
  {
    name: 'Dr. Lisa Wang',
    quote: 'Finally, an AI tool that shows its work. Xrystal brings accountability to machine learning.',
  },
  {
    name: 'Robert Kim',
    quote: 'The predictive power of Xrystal combined with its elegant design is simply unmatched.',
  },
];
